export function getApprovableMarketReferenceDates(reference) {
  const seen = new Set();
  return (Array.isArray(reference?.days) ? reference.days : [])
    .filter((day) => {
      const stayDate = String(day?.stay_date || "").slice(0, 10);
      if (!/^\d{4}-\d{2}-\d{2}$/.test(stayDate) || seen.has(stayDate)) {
        return false;
      }
      if (day?.calculated_price == null || day?.application_status === "applied") {
        return false;
      }
      seen.add(stayDate);
      return true;
    })
    .map((day) => String(day.stay_date).slice(0, 10))
    .sort();
}

export function normalizeMarketReferenceDateSelection(reference, selectedDates) {
  const allowed = new Set(getApprovableMarketReferenceDates(reference));
  return [...new Set(Array.isArray(selectedDates) ? selectedDates : [])]
    .map((value) => String(value || "").slice(0, 10))
    .filter((stayDate) => allowed.has(stayDate))
    .sort();
}
